<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <AdaptiveImage class="mission-vision-card-bg" is-background :field="fields?.background">
        <div class="mission-vision-card-list">
          <div class="mission-vision-card-item" v-for="item in fields?.list" :key="item.id">
            <JssRichText :field="item?.fields?.title" class="mission-vision-card-item-title" />
            <JssRichText :field="item?.fields?.desc" class="mission-vision-card-item-desc" />
          </div>
        </div>
      </AdaptiveImage>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'MissionVisionCard',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() =>
      utils.overall.baseComClass(props.fields, 'mission-vision-card')
    );

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.mission-vision-card {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-bg {
    border-radius: 16px;

    .e-background-image__content {
      padding: 30px;
    }
  }

  &-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  &-item {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &-title {
      font-size: 24px;
      line-height: 1.2;
      font-weight: 700;
      color: $black;
    }

    &-desc {
      font-size: 16px;
      line-height: 24px;
      color: #404040;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    &-item {
      flex: 1;

      // 单项：右侧留白
      &:only-child {
        padding-right: 40px;
      }

      // 第二项：左侧留白 + 左侧分割线
      &:nth-child(2):last-child {
        padding-left: 40px;
        border-left: 1px solid #dbcfb6;
      }
    }
  }
}
</style>
